import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useSearchParams } from "react-router-dom";
import ExportIcon from "../../Icons/ExportIcon";
import SearchIcon from "../../Icons/SearchIcon";
import SwitchTab from "../../components/Reusable/SwitchTab";

const GeneralLedgerComponent = loadable(
  () => import("../../components/GeneralLegder/LedgerAccount")
);

export default () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabs = [
    {
      id: "ledger-account",
      label: " Account",
      href: "/accounting/general-ledger-account",
    },
    {
      id: "ledger-party",
      label: " Party",
      href: "/accounting/general-ledger-party",
    },
    {
      id: "party-summary",
      label: " Party Summary",
      href: "/accounting/general-ledger-party-summary",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} />
      <GeneralLedgerComponent />
    </>
  );
};

